export default {
  data() {
    return {
      visible: false,
      popupStyle: { visibility: 'hidden' },
      tooltipHideTimer: null,
    };
  },
  watch: {
    visible(visible) {
      if (visible) {
        window.addEventListener('resize', this.updatePopupPosition);
        window.addEventListener('scroll', this.updatePopupPosition, true);
        this.$nextTick(this.updatePopupPosition);
      } else {
        this.removeTooltipPositionListeners();
      }
    },
  },
  methods: {
    cancelTooltipHide() {
      if (this.tooltipHideTimer !== null) {
        clearTimeout(this.tooltipHideTimer);
        this.tooltipHideTimer = null;
      }
    },
    showTooltip() {
      this.cancelTooltipHide();
      if (!this.visible) this.popupStyle = { visibility: 'hidden' };
      this.visible = true;
    },
    hideTooltip() {
      this.cancelTooltipHide();
      this.visible = false;
    },
    scheduleTooltipHide() {
      this.cancelTooltipHide();
      // Allow moving from the icon across the gap into image navigation.
      this.tooltipHideTimer = setTimeout(this.hideTooltip, 100);
    },
    togglePopup() {
      if (this.visible) this.hideTooltip();
      else this.showTooltip();
    },
    updatePopupPosition() {
      const anchor = this.$refs.tooltip;
      const popup = this.$refs.popup;
      if (!this.visible || !anchor || !popup) return;

      const inheritedStyle = getComputedStyle(anchor);
      if (!anchor.isConnected || inheritedStyle.visibility === 'hidden' || inheritedStyle.display === 'none') {
        this.hideTooltip();
        return;
      }

      const bounds = anchor.getBoundingClientRect();
      const popupBounds = popup.getBoundingClientRect();
      const margin = 12;
      const gap = 5;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const left = Math.max(margin, Math.min(bounds.left, viewportWidth - popupBounds.width - margin));
      let top = bounds.bottom + gap;
      if (top + popupBounds.height > viewportHeight - margin) {
        top = bounds.top - popupBounds.height - gap;
      }
      top = Math.max(margin, Math.min(top, viewportHeight - popupBounds.height - margin));

      const nextStyle = {
        left: `${left}px`,
        top: `${top}px`,
        visibility: 'visible',
        fontFamily: inheritedStyle.fontFamily,
        fontSize: inheritedStyle.fontSize,
        color: inheritedStyle.color,
        textAlign: inheritedStyle.textAlign,
      };
      if (Object.entries(nextStyle).some(([key, value]) => this.popupStyle[key] !== value)) {
        this.popupStyle = nextStyle;
      }
    },
    handleClickOutside(event) {
      if (this.visible && !this.$refs.tooltip?.contains(event.target) && !this.$refs.popup?.contains(event.target)) {
        this.hideTooltip();
      }
    },
    removeTooltipPositionListeners() {
      window.removeEventListener('resize', this.updatePopupPosition);
      window.removeEventListener('scroll', this.updatePopupPosition, true);
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  updated() {
    this.updatePopupPosition();
  },
  beforeUnmount() {
    this.cancelTooltipHide();
    this.removeTooltipPositionListeners();
    document.removeEventListener('click', this.handleClickOutside);
  },
};
